//#region IMPORT
import React, { useState, useRef, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
/** Services Import */
import Commons from '../../../Services/Common/Common';
/** Components */
import M_TBM_BASIC from './M_TBM_BASIC';
import { Loading } from '../../../Components/MUIs';
import Global from '../../../Services/Common/Global';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { CommonActions } from '../../../Reducer/CommonReducer';
import { NavBarInfoActions } from '../../../Reducer/NavBarInfoReducer';
import { useAppNavigate } from '../../../Hooks/back/useAppNavigate';
//#endregion

function M_TBM_BASICF() {
  //#region 변수
  const dispatch = useDispatch();
  const activeStep = useSelector((state) => state.common.activeStep);
  const { navigate } = useAppNavigate();
  const [loading, setLoading] = useState(false);
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);
  //로그인한 user 정보

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    type: 'info',
  });
  const [messages, setMessages] = useState([]);
  const [userCount, setUserCount] = useState(0);
  const [check, setCheck] = useState([]);
  const [ready, setReady] = useState(false);
  const ws = useRef(null); // WebSocket 인스턴스를 useRef로 저장
  const tbmCdRef = useRef(null);
  const [gjList, setGjList] = useState([]);
  const [modalToggle1, setModalToggle1] = useState(false); // 대기 모달
  const [modalToggle2, setModalToggle2] = useState(false); // 대기 모달
  const [modalToggle3, setModalToggle3] = useState(false); // 종료 모달
  const modalToggleRef = useRef(modalToggle1);
  //#endregion
  useEffect(() => {
    modalToggleRef.current = modalToggle1;
  }, [modalToggle1]);

  useEffect(() => {
    Init();
    // 스택형 뒤로가기로 변경
    dispatch(NavBarInfoActions.setType('titleBar'));
    dispatch(NavBarInfoActions.setTitleName('TBM'));
    dispatch(NavBarInfoActions.setBgColor('#F3F7F8'));

    let listener;
    if (Capacitor.isNativePlatform()) {
      listener = App.addListener('appStateChange', async (state) => {
        if (state.isActive) {
          // 앱이 포그라운드로 돌아옴
          // 웹소켓 연결 상태 확인
          if (!ws.current || ws.current.readyState !== WebSocket.OPEN) {
            console.log('웹소켓 연결이 끊어져 있음. 재연결 시도...');
            try {
              // 기존 연결 닫기
              if (ws.current) {
                ws.current.close();
              }
              // 새 연결 시도
              await OpenWebSocket();
              console.log('웹소켓 재연결 완료');
            } catch (error) {
              console.error('웹소켓 재연결 실패:', error);
              setSnackbar((prev) => ({
                ...prev,
                open: true,
                message:
                  '연결을 복구할 수 없습니다. 페이지를 새로고침해주세요.',
                type: 'error',
              }));
            }
          } else {
            console.log('웹소켓 연결 상태 정상');
            SearchLogic2();
          }
        } else {
          // 앱이 백그라운드로 감
        }
      });
    }

    return () => {
      if (ws.current) {
        ws.current.close(); // ✅ 언마운트 시 연결 닫기
      }
      if (listener) {
        listener.remove();
      }
    };
  }, [dispatch]); // eslint-disable-line react-hooks/exhaustive-deps

  const Init = async () => {
    setLoading(true);

    try {
      const stepperData = { step: activeStep };
      if (stepperData && stepperData.step !== 0) {
        dispatch(CommonActions.setActiveStep(stepperData.step));
      } else {
        dispatch(CommonActions.setActiveStep(0));
      }
      await SearchLogic1();
      await OpenWebSocket();
      await SearchGj();
      // await SaveLogic1();
    } catch (e) {
      console.log('Error: ', e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  //#region 조회
  // TBM_CD 조회
  const SearchLogic1 = async () => {
    setLoading(true);

    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_TBM_R1',
            _USER_ID: userInfo.userid,
            _AUTH_CD: Commons.EncryptAES(userInfo.authCd),
          },
        ]
      ).then((result) => {
        let data = result.data;

        if (data.length > 0) {
          if (data[0].type === 'Error') {
            throw new Error(data[0].message);
          } else {
            tbmCdRef.current = data[0].TBM_CD;
          }
        }
      });
    } catch (e) {
      console.log(e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };
  // tbmstatus 교육현황 조회
  const SearchLogic2 = async () => {
    setLoading(true);

    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_TBM_STATUS_R1',
            _TBM_CD: Commons.EncryptAES(tbmCdRef.current),
          },
        ]
      ).then((result) => {
        let data = result.data;

        if (data.length > 0) {
          if (data[0].type === 'Error') {
            throw new Error(data[0].message);
          } else {
            tbmCdRef.current = data[0].TBM_CD;

            dispatch(CommonActions.setActiveStep(data[0].E_STEP));
          }
        } else {
          // tbmCd가 없어진 경우 강제종료
          ws.current.close();
          dispatch(CommonActions.setActiveStep(0));
          navigate('/Home');
        }
      });
    } catch (e) {
      console.log(e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };
  // 공정 조회
  const SearchGj = async () => {
    setLoading(true);
    setGjList([]);

    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_SITE_GJ_R1',
            _userid: userInfo.userid,
            _authCd: Commons.EncryptAES(userInfo.authCd) || '',
          },
        ]
      ).then((result) => {
        let data = result.data;

        if (data.length > 0) {
          if (data[0].type === 'Error') {
            throw new Error(data[0].message);
          } else {
            // 데이터를 원하는 형식으로 변환
            const formattedData = data
              .map((item) => {
                // GJ_CD와 GJ_NM을 콤마로 분리
                const gjCd = item.GJ_CD;
                const gjNmList = item.GJ_NM ? item.GJ_NM.split(',') : [];

                // 결과 배열 생성
                return gjNmList.map((GJ_NM) => ({
                  GJ_CD: gjCd,
                  GJ_NM,
                }));
              })
              .flat();

            setGjList(formattedData);
            // // 데이터를 원하는 형식으로 변환,,
            // const formattedData = data
            //   .map((item) => {
            //     // GJ_CD와 GJ_NM을 콤마로 분리
            //     const gjCdList = item.GJ_CD.split(",");
            //     const gjNmList = item.GJ_NM.split(",");

            //     // 결과 배열 생성
            //     return gjCdList.map((gjCd, index) => ({
            //       GJ_CD: gjCd,
            //       GJ_NM: gjNmList[index],
            //     }));
            //   })
            //   .flat();

            // setGjList(formattedData);
          }
        } else {
          setSnackbar({
            ...snackbar,
            open: true,
            message: '공정이 등록되지 않았습니다. 관리자에게 문의하세요.',
            type: 'warning',
          });
        }
      });
    } catch (e) {
      console.log(e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };
  //#endregion

  //#region 저장
  // tbmmember 공정 저장
  // const SaveLogic1 = async () => {
  //   setLoading(true);
  //   let saveData = [];
  //   try {
  //     const gjCdString = gjList[0].GJ_CD;
  //     console.log(gjCdString);
  //     //const gjNmString = gjList.map((item) => item.GJ_NM).join(", ");

  //     saveData.push({
  //       procedureName: 'SP_TBM_MEMBER_U2',
  //       _TBM_CD: Commons.EncryptAES(tbmCdRef.current) || '', // TBM코드
  //       _USER_ID: userInfo.userid, // 참석자ID
  //       _DEP_CD: Commons.EncryptAES(gjCdString) || '', // 공정코드
  //     });

  //     if (saveData.length > 0) {
  //       await Commons.Axios(
  //         'post1',
  //         Global.base.useUrl + Global.urls.Execute.execute,
  //         saveData
  //       ).then(async (result) => {
  //         let data = result?.data[0];

  //         if (data.type === 'Error') {
  //           throw new Error(data.message);
  //         } else {
  //           // setSnackbar({
  //           //   open: true,
  //           //   type: "success",
  //           //   message: "저장되었습니다.",
  //           // });
  //           // setModalToggle1(true);
  //         }
  //       });
  //     }
  //   } catch (e) {
  //     console.log(e);
  //     setSnackbar({
  //       ...snackbar,
  //       open: true,
  //       message: e.message,
  //       type: 'error',
  //     });
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  //#endregion

  //#region 나머지함수
  // 웹소켓 서버 연결
  const OpenWebSocket = useCallback(async () => {
    // WebSocket 서버에 연결 (ws:// 또는 wss://)
    ws.current = new WebSocket(
      `${process.env.REACT_APP_WEB_SOCKET}?roomId=${tbmCdRef.current}&userId=${userInfo.userid}`
    );

    // 연결 성공 시
    ws.current.onopen = () => {
      console.log('웹소켓 연결됨');
      SearchLogic2();
    };

    // 메시지 수신 시
    ws.current.onmessage = (event) => {
      const HandleText = (text) => {
        try {
          const data = JSON.parse(text);

          if (data.type === 'userCount') {
            // 현재 인원수
            setUserCount(data.count);
          } else if (data.type === 'message') {
            // 채팅
            setMessages((prev) => [...prev, data.content]);
          } else if (data.type === 'prev') {
            // 이전단계
            if (data.content) {
              const adminStep = data.step;

              setModalToggle2(false); // 이전 페이지 넘어갈때 열려있던 모달 닫기
              dispatch(CommonActions.setActiveStep(adminStep));
            }
          } else if (data.type === 'next') {
            // 다음단계

            if (data.content) {
              const adminStep = data.step;

              if (modalToggleRef.current === true) {
                setModalToggle1(false);
                dispatch(CommonActions.setActiveStep(adminStep));
              } else {
                setModalToggle2(true);
                setTimeout(() => {
                  setModalToggle2(false);
                  dispatch(CommonActions.setActiveStep(adminStep));
                }, 3000);
              }
            }
          } else if (data.type.includes('check')) {
            // 교육여부 체크
            setCheck((prev) => {
              if (
                !prev.some(
                  (item) => item.id === data.id && item.type === data.type
                )
              ) {
                return [...prev, data]; // id, type가 다르면 추가
              }
              return prev; // 이미 존재하면 그대로 prev 반환
            });
          } else if (data.type === 'end') {
            ws.current.close();

            setModalToggle3(true);
            setTimeout(() => {
              setModalToggle3(false);
              dispatch(CommonActions.setActiveStep(0));
              navigate('/Home');
            }, 3000);
          } else if (data.type === 'endEm') {
          }
        } catch (e) {
          console.warn('JSON 파싱 실패:', e);

          setMessages((prev) => [...prev, text]);
        }
      };

      // 1. 메시지가 Blob이라면
      if (event.data instanceof Blob) {
        const reader = new FileReader();
        reader.onload = () => {
          const text = reader.result;
          setMessages((prev) => [...prev, text]);
        };
        reader.readAsText(event.data); // ← Blob을 문자열로 변환
      } else {
        // 2. 메시지가 문자열이라면
        HandleText(event.data);
      }
    };

    // 에러 처리
    ws.current.onerror = (error) => {
      console.error('WebSocket 오류:', error);
    };

    // 연결 종료 시
    ws.current.onclose = () => {
      console.log('웹소켓 연결 종료됨');
    };

    // 컴포넌트 언마운트 시 WebSocket 닫기
    return () => {
      ws.current.close();
    };
  }, [tbmCdRef, navigate, setMessages]);

  const ActiveButton = (_data) => {
    ws.current.send(JSON.stringify(_data));
  };
  //#endregion

  const TbmEnd = () => {
    dispatch(CommonActions.setActiveStep(0));
    ws.current.close();
  };

  return (
    <div className="wrap">
      <M_TBM_BASIC
        // 변수
        userInfo={userInfo}
        lanList={lanInfo}
        activeStep={activeStep}
        setActiveStep={(step) => dispatch(CommonActions.setActiveStep(step))}
        userCount={userCount}
        setUserCount={setUserCount}
        check={check}
        setCheck={setCheck}
        ready={ready}
        setReady={setReady}
        tbmCdRef={tbmCdRef}
        gjList={gjList}
        setModalToggle1={setModalToggle1}
        modalToggle1={modalToggle1}
        setModalToggle2={setModalToggle2}
        modalToggle2={modalToggle2}
        setModalToggle3={setModalToggle3}
        modalToggle3={modalToggle3}
        // 함수
        ActiveButton={ActiveButton}
        TbmEnd={TbmEnd}
      />
      <Loading open={loading} />
    </div>
  );
}

export default M_TBM_BASICF;
